import type { Module } from "@webmotors/ioc";
import { CryptoService } from "./crypto.service";

export const CryptoModule: Module = {
  name: "CryptoModule",
  modules: [],
  providers: [CryptoService],
};
